



































import Vue from 'vue';
import { defineComponent, ref, Ref, computed, onMounted } from '@vue/composition-api';
import { generateRandomId } from 'wok-components/src/helpers';
import { useWrapperClasses, useInputClasses } from 'wok-components/src/input/abstractions';

export default defineComponent({
    name: "WokInputTextAreaDir",

    props: {
        name: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            dafault: ''
        },
        error: {
            type: Object,
            default: null
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        reset: {
            type: String,
            default: ''
        },
        showReset: {
            type: Boolean,
            default: false
        },
        actionSequentialFocus: {
            type: Boolean,
            default: false
        },
        testName: {
            type: String,
            default: undefined
        },
        dir: {
            type: String,
            default: "ltr"
        }
    },

    setup(props, context) {

        const id = generateRandomId(props.name);

        const textAreaElement = ref() as Ref<HTMLTextAreaElement>;
        const formattedValue = computed(() => props.value || '');

        const onInput = (evt: Event) => {
            if (evt.target instanceof HTMLTextAreaElement) {
                autoExpand(textAreaElement.value);
                context.emit('input', evt.target.value);
            }
        }

        const autoExpand = (el: HTMLTextAreaElement) => {
            // Reset field height
            el.style.height = 'inherit';

            // Get the computed styles for the element
            let computed = window.getComputedStyle(el);

            // Calculate the height
            let height = el.scrollHeight + parseInt(computed.getPropertyValue('border-bottom-width'), 10);

            el.style.height = `${height}px`;
        }

        const onReset = () => context.emit('input', props.reset);

        onMounted(() => {
            if (textAreaElement.value) {
                autoExpand(textAreaElement.value);
            }
        });

        return {
            id,
            computedTestName: computed(() => props.testName ?? props.name),
            textAreaElement,
            wrapperClasses : useWrapperClasses(props, context.attrs),
            inputClasses : useInputClasses('textarea', computed(() => props.showReset)),
            formattedValue,
            onInput,
            onReset
        }
    }
})
